import { render } from "./index.vue.js?vue&type=template&id=ec93ac00!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./index.vue?vue&type=template&id=ec93ac00"
const script = {  }

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__